import { api } from '../../lib/api';
import type {
  AcquisitionBreakdown,
  AnalyticsOverview,
  OnboardingFunnel,
  OnboardingPlatform,
  PlanAdviceMix,
  StornoVergleich,
  LektionsSucheGuete,
  SchoolAttendanceBreakdown,
  SubscriptionFunnel,
  TimeseriesMetric,
  TimeseriesPoint,
  TopTopic,
} from './types';

// Alle KPIs pro App (`?app=` aus dem globalen Picker). Aktivität + Entitlements
// scopen auf die App; signups/Gesamt-Nutzer bleiben app-übergreifend (Backend).
const ap = (app: string) => `app=${encodeURIComponent(app)}`;

export function fetchOverview(app: string): Promise<AnalyticsOverview> {
  return api.get<AnalyticsOverview>(`/admin/analytics/overview?${ap(app)}`);
}

export function fetchTimeseries(
  metric: TimeseriesMetric,
  app: string,
  days = 30,
): Promise<TimeseriesPoint[]> {
  return api.get<TimeseriesPoint[]>(
    `/admin/analytics/timeseries?metric=${metric}&days=${days}&${ap(app)}`,
  );
}

export function fetchTopTopics(app: string, days = 30, limit = 10): Promise<TopTopic[]> {
  return api.get<TopTopic[]>(`/admin/analytics/top-topics?limit=${limit}&days=${days}&${ap(app)}`);
}

export function fetchSubscriptionFunnel(app: string): Promise<SubscriptionFunnel> {
  return api.get<SubscriptionFunnel>(`/admin/analytics/subscription-funnel?${ap(app)}`);
}

export function fetchAcquisition(app: string, days = 30): Promise<AcquisitionBreakdown> {
  return api.get<AcquisitionBreakdown>(`/admin/analytics/acquisition?days=${days}&${ap(app)}`);
}

export function fetchSchoolAttendance(app: string): Promise<SchoolAttendanceBreakdown> {
  return api.get<SchoolAttendanceBreakdown>(`/admin/analytics/school-attendance?${ap(app)}`);
}

export function fetchOnboardingFunnel(
  app: string,
  days = 30,
  platform: OnboardingPlatform = 'all',
): Promise<OnboardingFunnel> {
  return api.get<OnboardingFunnel>(
    `/admin/analytics/onboarding-funnel?days=${days}&platform=${platform}&${ap(app)}`,
  );
}

export function fetchPlanAdviceMix(app: string, days = 30): Promise<PlanAdviceMix> {
  return api.get<PlanAdviceMix>(`/admin/analytics/plan-advice-mix?days=${days}&${ap(app)}`);
}

export function fetchStornoVergleich(app: string, days = 30): Promise<StornoVergleich> {
  return api.get<StornoVergleich>(`/admin/analytics/storno-vergleich?days=${days}&${ap(app)}`);
}

export function fetchLektionsSuche(app: string, days = 30): Promise<LektionsSucheGuete> {
  return api.get<LektionsSucheGuete>(`/admin/analytics/lektionssuche?days=${days}&${ap(app)}`);
}
